<div class="wrapper wrapper-content animated fadeInRight">
  <div class="container-fluid ">
    <div class="row border-bottom m-b">
      <div class="col-lg-9">
        <h2 class="m-t-xs d-inline-block"> {{ 'MainView.welcome' | translate }} {{userFullName}} </h2>
        <span class="p-w-m">
          <a class="fa fa-info-circle text-info" aria-hidden="true" (click)="showMessage ()"></a>
          <small> ({{ 'Navigation.lastLogin' | translate }} {{lastLogin|date :'dd/MM/y HH:mm'}})</small>
        </span>
      </div>
      <div class="col-lg-3 m-b" *ngIf="dashBoardsOptions && dashBoardsOptions.length > 1">
        <p-dropdown [options]="dashBoardsOptions" [ngModel]="activeDashBoard" (onChange)="loadComponents($event.value)"
          dataKey="id">
        </p-dropdown>
      </div>
    </div>
    <div class="col-12" style="margin-left: 15px;" *ngIf="formConfig">
      <formPlyca #formPlycaRef [formConfig]="formConfig" [manageWaitService]=false>
      </formPlyca>
    </div>
    <ng-template #parent></ng-template>
  </div>
</div>